<template>
  <div>
    <OrganizationDashboardInvitations class="mt-2" />
    <BaseTitle class="mb-6" v-text="$tc('organization.collaborator', 2)" />
    <OrganizationDashboardCollaborators />
  </div>
</template>
<script>
import OrganizationDashboardCollaborators from "@/core/Components/OrganizationDashboard/OrganizationDashboardCollaborators";
import OrganizationDashboardInvitations from "@/core/Components/OrganizationDashboard/OrganizationDashboardInvitations";

export default {
  name: "CollaboratorsManagement",
  components: {
    OrganizationDashboardCollaborators,
    OrganizationDashboardInvitations,
  },
};
</script>
